import React from "react";
import { Button, Modal } from "react-bootstrap";
import { EmbedFormBtn } from "./embedFormButtons";

/** Single-action notice dialog for embed-forms UI. */
export default function EmbedFormAlertModal({
    show,
    onHide,
    title = "Notice",
    message,
    buttonLabel = "OK",
}) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="embed-forms-ui"
        >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button type="button" variant={EmbedFormBtn.primary} onClick={onHide}>
                    {buttonLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
